import { render } from "./ShowButtonOnSaleCountdown.vue?vue&type=template&id=4b42387a&ts=true"
import script from "./ShowButtonOnSaleCountdown.vue?vue&type=script&lang=ts"
export * from "./ShowButtonOnSaleCountdown.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\WebDev\\Source\\WendoverFun.com\\[WWW]\\[WEB] WendoverFun.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__